export default {
  levelsList: [],
  achievementsList: [],
  playerProfile: null
}
